import { Layout, Step, Stepper, } from "@mcleod/components";

export abstract class AutogenLayoutCarrierAssignmentStepper extends Layout {
    carrierAssignmentStep: Step;
    initiateTrackingStep: Step;
    sendRateConStep: Step;
    stepper: Stepper;
}
